<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";

import {ChallengeType} from "@/modules/redactor/models/challenge/ChallengeType";

export default {
  name: "r-challenge-type",
  props: {
    model: VueTypes.instanceOf(ChallengeType),
    label: VueTypes.string.def("Type:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return ChallengeType.getValues();
    }
  }
}
</script>